import React from 'react';
import { taskStore, appStore, TaskStore, AppStore, Stores } from '../store';
import { bytesToSize } from '../util';
import { sendCommandToDefault } from '../socket';
import { LoadingScreen, dialogEvents } from '../component';
import { Panel } from '../component/ui';
import setIntervals from '../interval';
import { intervals } from '../api-layer';
import { InputWithConfirm } from '../component/input';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import { DataTable } from '../component/table/dataTable';
import filesize from 'filesize';
import { Button } from '../component/button';
import { theme } from '../styles/theme';
import { Stats } from './system';

/** Process creator widget. */
export class ProcessCreator extends React.Component<
  {},
  { exe: string; box?: any }
> {
  startProcess = () => {
    if (this.state && this.state.exe) {
      //console.log(this.state.exe)
      sendCommandToDefault('startProcess', this.state.exe);
      if (this.state.box) {
        this.state.box.value = '';
      }
    }
  };
  render() {
    const createButton = (
      <Button
        onClick={this.startProcess}
        content="start"
        style={{ color: theme.primaryColor }}
      />
    );
    return (
      <div className="kabuto-bare-input-button">
        <InputWithConfirm
          placeholder="Enter new process name..."
          onChange={(e, value) =>
            this.setState({
              exe: value,
              box: e.target,
            })
          }
          onConfirm={e => {
            this.startProcess();
          }}
          confirmButton={createButton}
        />
      </div>
    );
  }
}

type TaskListOwnProps = {};
type TaskListStoreProps = { taskStore: TaskStore; appStore: AppStore };
type TaskListProps = TaskListOwnProps & TaskListStoreProps;

class TaskDataTable extends DataTable<TaskInfo> {}

class TaskListComp extends React.Component<TaskListProps, {}> {
  componentDidMount() {
    if (this.props.appStore.auth.loggedIn) {
      _.assign(intervals, setIntervals());
    }
  }

  componentWillUnmount() {
    _.forEach(intervals, (v: number, k) => {
      clearInterval(v);
    });
  }

  killProcess = (id: number) => {
    sendCommandToDefault('killProcess', id.toString());
  };

  confirmKill = (task: TaskInfo) => {
    dialogEvents.dialog({
      title: 'Confirm close process',
      body: <p>Are you sure you want to kill process {task.name}?</p>,
      buttons: [
        <Button
          key="yes"
          primary
          onClick={() => this.killProcess(task.id)}
          content="Yes"
        />,
        <Button key="no" content="No" onClick={() => {}} />,
      ],
    });
  };

  render() {
    if (this.props.taskStore.tasks.length == 0) {
      return <LoadingScreen>Loading task list</LoadingScreen>;
    }

    return (
      <TaskDataTable
        divided
        sortable
        initialSortField={t => t.cpuUsage}
        initialSortOrder="desc"
        dataKey="id"
        columns={[
          {
            header: 'Icon',
            render: t => <img src={`data:image/png;base64,${t.icon}`} />,
          },
          { header: 'Name', render: t => t.name, sortField: t => t.name },
          { header: 'Id', render: t => t.id },
          {
            header: 'CPU',
            align: 'right',
            render: t =>
              (t.cpuUsage / 100).toLocaleString([], {
                style: 'percent',
                minimumFractionDigits: 1,
              }),
            sortField: t => t.cpuUsage,
          },
          {
            header: 'Memory',
            align: 'right',
            render: t => filesize(t.ramUsage, { round: 0 }),
            sortField: t => t.ramUsage,
          },
          {
            header: '',
            key: 'kill',
            render: t => (
              <Button
                icon="x"
                transparent
                onClick={() => this.confirmKill(t)}
              />
            ),
          },
        ]}
        data={this.props.taskStore.tasks}
      />
    );
  }
}

export const TaskList = inject<
  Stores,
  TaskListOwnProps,
  TaskListStoreProps,
  {}
>(({ appStore, taskStore }) => ({ appStore, taskStore }))(
  observer(TaskListComp),
) as React.ComponentClass<TaskListOwnProps>;

/** Top level container page. Has the process list, creator and system stats. */
export function TaskPage(props: { path: string }) {
  return (
    <div className="task-page" style={{ height: '100%' }}>
      <div className="row" />
      <div className="row" style={{ height: '100%' }}>
        <div
          className="col-md-7"
          style={{ minHeight: '600px', height: '100%' }}
        >
          <Panel className="full-height">
            <div className="header">processes</div>
            <div className="fixed dashed-bottom" style={{ height: 43 }}>
              <ProcessCreator />
            </div>
            <div className="body" style={{ overflow: 'auto' }}>
              <TaskList />
            </div>
          </Panel>
        </div>
        <div className="col-md-5 col-collapsed-left">
          <div>
            <Stats />
          </div>
        </div>
      </div>
    </div>
  );
}
